import { memo, useState, useEffect, useCallback, useMemo, forwardRef, useImperativeHandle } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BzModal, BzModalHeader, BzTabs, BzTab, BzToggleButton, BzTabsContainer, BzModalTitle, BzModalBody } from '../../components';
import { ConfirmationModal, OrderStatus, OrderSingleScrip, OrderMultiScrip, OrderSip } from './';
import { getEqSipScripMaster, getExchangeWiseScripInfo, getLTPPriceBand, getMarketStatusFailure, getMultiLegData, getOrderMarginInfo, getScripOrderInfo, getSpreadOrderSuccess, orderMarginInfoFailure, updateResetScrip } from '../../redux/actions/orders';
import { handleModal, handleModalData } from '../../redux/actions/modals';

import {
    ORDER_ENTRY_CONSTANTS, WATCHLIST_GRID_INDEX, ORDER_TYPES, ORDER_ENTRY_BUTTON_TOGGLE, ORDER_PRODUCT_TYPES,
    MARKET_SEGMENT_ID, SCRIP_INSTRUMENTS, ORDER_ENTRY_TYPES, FACILITY_NUM, LAYOUT_TYPE,
    ORDER_VALIDITY,
    GTD_DAYS_FOR_NCDEX,
    FREQUENCY_TYPE,
} from '../../utils/global_variables';
import { getApiExchangeNameFromMktSegId, getDecryptLocalStorage, getGroupedSegement, getProductTypeValue, getToFixedParseFloat, getValidityByExchangeName, handleBlink, handleKeyDownOnDiv, isGuestUser, roundToNearest } from '../../utils/global_functions';
import OrderCartModal from './OrderCartModal';
import BrokerageCharges from './BrokerageCharges';
import dayjs from 'dayjs';
import moment from 'moment';
import { toastConfig } from '../../redux/actions/toast';
import { _isEQSIPOrderAllowed, _isShowValidityOrderEntry } from '../../controllers/orders';
import SaveCartCnfrmModal from './OrderMultiScrip/SaveCartCnfrmModal';
import { saveCartForGoback, saveCartSuccess, storeGridData, updateOrderCartRowData } from '../../redux/actions/orderCart';
import { setSelectedCategory } from '../../redux/actions/screeners';
import FocusLock from 'react-focus-lock';
const objSelectOrderOptionInit = {
    frequency: "MONTHLY",
    every: "First",
    day_date: "Date",
    day: "Monday",
    everyForWeekly: "MONDAY",
    productType: "",
    productTypeDesc: '',
    validityTypes: "DAY",
    orderType: ORDER_ENTRY_TYPES.RL,
    orderBy: 'Quantity',
    isAmo: false,
    isOCOChecked: false,// Azeem K:21-03-2025 BREEZE-131 Breeze - Introduction of GTT orders- OCO (One Cancels Other):BREEZE-4394 LLD Creation :added isOCOChecked field for control OCO checkbox
    selectSpecificFrequencyDate: 1,
    isDefaultProductType: true
};

let nFundsRequiredPerLot = 0.00;
let isScripPrice = true;
const OrderEntry = forwardRef(({ activeContent, isExpanded, orderEntryTab, tabSearchToggle, isBasket, setIsBasket = () => { }, setOrderEntryTab, activeTabKey, setActiveTabKey, modifyModal, onHideModifyModal, ordersTabKey, ...props }, ref) => {

    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [addToggle, setAddToggle] = useState(false);
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    const [toggleBracketOrder, setToggleBracketOrder] = useState({ isShow: false, strProductType: ORDER_PRODUCT_TYPES.COVER });
    const [arrAllExchangeWiseProductTypes, setArrAllExchangeWiseProductTypes] = useState([]);
    const [bIsPlaceOrderBtnDisabled, setBIsPlaceOrderBtnDisabled] = useState(false);
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
    const [count, setCount] = useState({ firstleg: 1, secondleg: 1 });

    const currentDate = new Date().toLocaleDateString("en-CA").split("/").reverse().join('-');

    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    const sipSettingDetails = useSelector(state => state?.orders?.sipSettingDetails);   // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 

    {/* Vinit R : 16-05-2024 :BT-107418 :Breeze - Order Book - SIP Order --- Start */ }
    const [orderInputs, setOrderInputs] = useState({
        scripQuantity: 1, scripLot: 1, scripAmount: 0, scripPrice: '', slTrigger: 0, quantity: 1, capPrice: 0, numberOfInstallment: 1, intradayTrigger: 0, intradayLimit: 0, intradayTrailing: 0, intradayProfit: 0, discQty: 0, protPercent: 0, startDate: currentDate, gtdDate: currentDate,
        targetSelPrice: 0, targetSelTriggerPrice: 0  // Azeem K:21-03-2025 BREEZE-131 Breeze - Introduction of GTT orders- OCO (One Cancels Other):BREEZE-4394 LLD Creation :added two fields for Target Price and Target Trigger Price  inputs 
    });
    {/* Vinit R : 16-05-2024 :BT-107418 :Breeze - Order Book - SIP Order --- End */ }
    const [buySellType, setBuySellType] = useState({});
    const [legDataInfo, setLegDataInfo] = useState([]);
    const [isDeletedFlag, setIsdeletedFlag] = useState({ firstleg: 0, secondleg: 0 });
    const [thirdlegData, setThirdLegData] = useState([]);
    const [isCheck, setIsCheck] = useState([]);

    const [selectOrderOption, setSelectOrderOption] = useState(objSelectOrderOptionInit);
    const [isBrokerageDisabled, setIsBrokerageDisabled] = useState(false);
    // For Recommendations - start
    const modalData = useSelector(state => state?.modals?.modalData?.rowDetails);
    // For Recommendations - end
    const ltpPriceBandMaster = useSelector(state => state.orders.ltpPriceBandMaster);
    const objEqSIPScripMaster = useSelector(state => state.orders.objEqSIPScripMaster);
    const arrMarginInfo = useSelector(state => state.orders.arrMarginInfo);
    const objScripOrderInfo = useSelector(state => state.orders.scripOrderInfo);
    const modals = useSelector(state => state.modals.modals);
    const objCFT = useSelector(state => state?.auth?.objCFT);
    const objSelectedTabs = useSelector(state => state?.optionChain?.objSelectedTabs);
    const objModalData = useSelector(state => state?.modals?.modalData);
    const isResetScrip = useSelector(state => state.orders.isResetScrip);
    const { scripOrderInfo, activeButtonToggleIndex, activeMktSegId, isModifyOrder = false, isReOrder = false, isMultilegReOrder = false, bIsHoldingsSell = false, nOriginalQty = 0 } = useMemo(() => ({ scripOrderInfo: objScripOrderInfo?.scripData, activeButtonToggleIndex: objScripOrderInfo?.isBuySell, activeMktSegId: objScripOrderInfo?.activeExchangeId, isModifyOrder: objScripOrderInfo?.isModifyOrder, isReOrder: objScripOrderInfo?.isReOrder, bIsHoldingsSell: objScripOrderInfo?.bIsHoldingsSell, nOriginalQty: objScripOrderInfo?.nOriginalQty, isMultilegReOrder: objScripOrderInfo?.isMultilegReOrder }), [objScripOrderInfo]);
    const bIsCartSavedSuccess = useSelector(state => state.orderCart.bIsCartSaved);
    const arrGridData = useSelector(state => state.orderCart.arrOrderEntryGridData); //BT-106965 : OrderCart : ManasaB : 27/02/2024
    //Maaz A : 10-10-2023 : BT-102298 - Breeze - Single Scrip Order entry : GTD Order - Start

    const defaultGtdDate = useMemo(() => {
        return dayjs(moment().add(scripOrderInfo?.length && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES ? GTD_DAYS_FOR_NCDEX.DEFAULT_DATE : objLoginSession?.data?.others?.nGTDDefault, 'days').format('DD-MM-YYYY'), 'DD-MM-YYYY');
    }, [objLoginSession?.data?.others?.nGTDDefault, scripOrderInfo]);

    useEffect(() => {
        setOrderInputs(curr => ({ ...curr, gtdDate: defaultGtdDate }));
    }, [defaultGtdDate]);
    //Maaz A : 10-10-2023 : BT-102298 - Breeze - Single Scrip Order entry : GTD Order - End

    //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - Start
    const orderQuantityCaption = useMemo(() => {
        if (scripOrderInfo?.length > 0) {
            let arrTypeCaption = [];
            let objUserOrderPreference = getDecryptLocalStorage('PREFERRED_ORDER_SELECTION');
            if (objUserOrderPreference && objUserOrderPreference?.length > 0) {
                objUserOrderPreference = JSON.parse(objUserOrderPreference);
            } else {
                objUserOrderPreference = {};
            }
            const strScripSegment = getGroupedSegement(scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE], scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT]);

            if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) {
                arrTypeCaption = [{ type: 'Quantity', isDefault: false }, { type: 'Amount', isDefault: false }];
            } else {
                arrTypeCaption = [{ type: 'Lot', isDefault: false }, { type: 'Quantity', isDefault: false }, { type: 'Amount', isDefault: false }];
            }
            if (objUserOrderPreference[strScripSegment]?.type) {
                const nIndex = arrTypeCaption?.findIndex(obj => obj.type === objUserOrderPreference[strScripSegment]?.type);
                if (nIndex >= 0) {
                    arrTypeCaption[nIndex] = objUserOrderPreference[strScripSegment];
                } else { }
            } else { }
            return [...arrTypeCaption];
        } else {
            return [{ type: 'Quantity', isDefault: false }, { type: 'Amount', isDefault: false }];
        }
    }, [scripOrderInfo]);

    useEffect(() => {
        if (orderQuantityCaption?.length > 0 && scripOrderInfo?.length > 0) {
            let objDefaultType = orderQuantityCaption?.find(obj => obj.isDefault);
            if (!objDefaultType?.type) {
                objDefaultType = orderQuantityCaption[0];
            } else { }
            handleOnSelectOrderOptionChange({ target: { name: 'orderBy', value: objDefaultType.type } });
            if (!isModifyOrder && !isReOrder) {
                switch (objDefaultType.type) {
                    case 'Lot': {
                        handleOrderInputs({ target: { name: 'scripLot', value: orderInputs?.scripLot } });
                        break;
                    }
                    case 'Quantity': {
                        handleOrderInputs({ target: { name: 'scripQuantity', value: orderInputs?.scripLot * scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT] } });
                        break;
                    }
                    case 'Amount': {
                        handleOrderInputs({ target: { name: 'scripAmount', value: '0' } });
                        break;
                    }
                    default:
                        break;
                }
            } else { }
            //Ameersha N : 08-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - Resetign scrip scrplot and trigger when a search scrip is selected - Start
            if (isResetScrip) {
                handleOrderInputs({ target: { name: 'scripLot', value: 1 } });
                handleOrderInputs({ target: { name: 'slTrigger', value: '0.00' } });
                setTimeout(() => {
                    dispatch(updateResetScrip(false));
                }, 2000);
            } else { }
            //Ameersha N : 08-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - Resetign scrip scrplot and trigger when a search scrip is selected - End
        } else { }
    }, [orderQuantityCaption, isModifyOrder, isResetScrip, dispatch]);
    //Maaz A : 27-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start


    //Maaz A : 27-09-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

    // {/* Vinit Raut : 27-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start  */ }
    useEffect(() => {
        if (scripOrderInfo?.length > 0) {
            dispatch(getExchangeWiseScripInfo(scripOrderInfo));

            // Ajitesh 07-10-2024 Removed multileg objcft condition  as second if checks for basket order
            if (objCFT?.BULKORDER) {
                //  BT-106965 : Ordercart : SAT1 Issues : ManasaB : 25-04-2024 -Start
                if (isBasket || objModalData?.data?.isGoBack || objModalData?.data?.activeTabKey === ORDER_TYPES.BASKET) { //BT-106965 : ManasaB : 10-05-2024 : To open order cart when spreads are there  in GoBack condition
                    setActiveTabKey(ORDER_TYPES.BASKET);
                }
                //  BT-106965 : Ordercart : SAT1 Issues : ManasaB : 25-04-2024 - End
                else if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.NSPREAD] === 1) {
                    // setOrderEntryTab(ORDER_TYPES.MULTI_SCRIP);
                    //  BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 -Start
                    if (objCFT?.MULTILEG) {
                        setActiveTabKey(ORDER_TYPES.SPREAD);
                    } else if (objCFT?.BULKORDER) {
                        setActiveTabKey(ORDER_TYPES.BASKET);
                    } else { }
                    //  BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 -End
                } else {
                    // setOrderEntryTab(ORDER_TYPES.MULTI_SCRIP);
                    // (--COMMENTED_for_solving_activeTab_issue_on_Search/ Srikantrao-BT-102676 Breeze_22-11-2023--)
                    // Ajitesh 07-10-2024 If user has multileg allowed show multileg if not only then go to basket
                    if (objCFT?.MULTILEG) {
                        setActiveTabKey(ORDER_TYPES.MULTI_LEG);
                    } else {
                        setActiveTabKey(ORDER_TYPES.BASKET);
                    }
                }
            }
        } else { }
    }, [scripOrderInfo, objCFT?.BULKORDER, setActiveTabKey, setOrderEntryTab, objCFT?.MULTILEG, isBasket, dispatch]);//Ameersha N - 14-12-2023 -missing dependency has been addded
    // {/* Vinit Raut : 27-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- End  */ }

    // {/* Vinit Raut : 27-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start  */ }
    // useEffect(() => {
    //     if (objModalData?.orderType) {
    //         setOrderEntryTab(objModalData?.orderType);
    //     } else {
    //         setOrderEntryTab(ORDER_TYPES.SINGLE_SCRIP);
    //     }
    // }, [objModalData?.orderType]);
    // {/* Vinit Raut : 27-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- End  */ }

    //Maaz A : 17-11-2023 : Client Facility Template - Added for MultiLeg and Spread - End
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    useEffect(() => {
        if (orderEntryTab === ORDER_TYPES.MULTI_SCRIP) {
            setBIsPlaceOrderBtnDisabled(false);
        } else
            //Maaz A : 15-12-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Fixes- Start
            if (orderEntryTab === ORDER_TYPES.SINGLE_SCRIP) {
                if (scripOrderInfo?.length > 0) {
                    if (selectOrderOption?.orderBy === 'Quantity') {
                        if (isNaN(parseFloat(orderInputs?.scripPrice)) || !selectOrderOption?.productType || (parseFloat(orderInputs?.scripPrice) === 0 && (selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.RL_MKT && selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.SL_MKT)) || isNaN(parseInt(orderInputs?.scripQuantity)) || parseInt(orderInputs?.scripQuantity) === 0 || ((selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES?.SL) || selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT) && (isNaN(parseFloat(orderInputs?.slTrigger)) || parseFloat(orderInputs?.slTrigger) === 0)) || (selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT && selectOrderOption?.isOCOChecked && (isNaN(parseFloat(orderInputs?.targetSelPrice)) || parseFloat(orderInputs?.targetSelPrice) === 0 || isNaN(parseFloat(orderInputs?.targetSelTriggerPrice)) || parseFloat(orderInputs?.targetSelTriggerPrice) === 0))) { // BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 - added condition for trigger price in case of GTT
                            setBIsPlaceOrderBtnDisabled(true);
                        }
                        else {
                            setBIsPlaceOrderBtnDisabled(false);
                        }
                    } else if (selectOrderOption?.orderBy === 'Amount') {
                        if (isNaN(parseFloat(orderInputs?.scripPrice)) || !selectOrderOption?.productType || isNaN(parseInt(orderInputs?.scripQuantity)) || parseInt(orderInputs?.scripQuantity) === 0 || (parseFloat(orderInputs?.scripPrice) == 0 && (selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.RL_MKT && selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.SL_MKT)) || isNaN(parseFloat(orderInputs?.scripAmount)) || parseFloat(orderInputs?.scripAmount) === 0 || ((selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES?.SL) || selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT) && (isNaN(parseFloat(orderInputs?.slTrigger)) || parseFloat(orderInputs?.slTrigger) == 0)) || (selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT && selectOrderOption?.isOCOChecked && (isNaN(parseFloat(orderInputs?.targetSelPrice)) || parseFloat(orderInputs?.targetSelPrice) === 0 || isNaN(parseFloat(orderInputs?.targetSelTriggerPrice)) || parseFloat(orderInputs?.targetSelTriggerPrice) === 0))) {// BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 - added condition for trigger price in case of GTT
                            setBIsPlaceOrderBtnDisabled(true);
                        } else {
                            setBIsPlaceOrderBtnDisabled(false);
                        }
                    } else if (selectOrderOption?.orderBy === 'Lot') {
                        if (isNaN(parseFloat(orderInputs?.scripPrice)) || !selectOrderOption?.productType || (parseFloat(orderInputs?.scripPrice) == 0 && (selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.RL_MKT && selectOrderOption?.orderType !== ORDER_ENTRY_TYPES.SL_MKT)) || isNaN(parseInt(orderInputs?.scripLot)) || parseInt(orderInputs?.scripLot) == 0 || ((selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES?.SL) || selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT) && (isNaN(parseFloat(orderInputs?.slTrigger)) || parseFloat(orderInputs?.slTrigger) == 0)) || (selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT && selectOrderOption?.isOCOChecked && (isNaN(parseFloat(orderInputs?.targetSelPrice)) || parseFloat(orderInputs?.targetSelPrice) === 0 || isNaN(parseFloat(orderInputs?.targetSelTriggerPrice)) || parseFloat(orderInputs?.targetSelTriggerPrice) === 0))) {// BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 - added condition for trigger price in case of GTT
                            setBIsPlaceOrderBtnDisabled(true);
                        } else {
                            setBIsPlaceOrderBtnDisabled(false);
                        }
                    }
                    else { }
                } else {
                    setBIsPlaceOrderBtnDisabled(true);
                }
            } else {
                setBIsPlaceOrderBtnDisabled(false);
            }
        //Maaz A : 15-12-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Fixes- End

    }, [orderInputs?.scripPrice, orderInputs?.scripQuantity, orderInputs?.scripAmount, orderInputs?.scripLot, orderInputs?.slTrigger, selectOrderOption?.orderBy, selectOrderOption?.orderType, selectOrderOption?.productType, orderEntryTab, scripOrderInfo, selectOrderOption?.validityTypes, selectOrderOption?.isOCOChecked, orderInputs?.targetSelPrice, orderInputs?.targetSelTriggerPrice]);
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

    // Vinit R : 12-07-2024 : Fix payload object not updating on Buy/Sell -- Start
    const singleScripParams = useMemo(() => {
        return {
            "producttype": selectOrderOption?.productType,
            "transactiontype": activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.BUY ? 1 : 2,
            "quantity": orderInputs?.scripQuantity,
            "price": orderInputs?.scripPrice || 0,
            "mktType": selectOrderOption?.orderType
        };
    }, [selectOrderOption, activeButtonToggleIndex, orderInputs]);
    // Vinit R : 12-07-2024 : Fix payload object not updating on Buy/Sell -- End

    const multiScripParams = useMemo(() => {
        return {
            "producttype": 'CARRYFORWARD',
            "transactiontype": 1,
            "quantity": 1,
            "price": 0,
        };
    }, []);


    const addScript = useCallback((element) => {
        var Arr = [...element];
        setThirdLegData(Arr);
        dispatch(handleModal([{ "ADD_LEG_MODAL": false }]));
    }, [dispatch]);



    const getBrokerageParams = useCallback(() => {
        if (orderEntryTab === ORDER_TYPES.SINGLE_SCRIP) {
            return singleScripParams;
        }
        if (orderEntryTab === 'multi_scrip') {
            return multiScripParams;
        }
        return {};
    }, [multiScripParams, orderEntryTab, singleScripParams]);

    useEffect(() => {
        const params = getBrokerageParams();
        if (!params?.quantity || !params?.price) {
            setIsBrokerageDisabled(true);
        } else {
            setIsBrokerageDisabled(false);
        }
    }, [getBrokerageParams]);

    //PrachiTawde : 09-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - Start

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start

    const marginInfoHandler = useCallback((strProductType, nQuantity) => {
        let nPrice = parseFloat(orderInputs.scripPrice);
        if (toggleBracketOrder?.isShow) {
            if (!isNaN(parseFloat(orderInputs?.intradayLimit)) && parseFloat(orderInputs?.intradayLimit) > 0) {
                nPrice = parseFloat(orderInputs?.intradayLimit);
            } else {
                nPrice = 0;
            }
        } else {
            nPrice = parseFloat(orderInputs.scripPrice);
        }

        if (!strProductType) {
            strProductType = getProductTypeValue(selectOrderOption?.productType?.toUpperCase()) || '';
        } else {
            strProductType = getProductTypeValue(strProductType?.toUpperCase()) || '';
        }
        if (!nQuantity || nQuantity <= 0) {
            if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.NSE_DERIVATIVES || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.NCDEX_DERIVATIVES) {
                nQuantity = orderInputs.scripQuantity;
            } else {
                nQuantity = orderInputs.scripLot;
            }
        } else {
            nQuantity = parseInt(nQuantity);
        }

        const arrLegDetails = [
            {
                "LegNo": 1,
                "BuyOrSell": activeButtonToggleIndex + 1,
                "MarketSegmentId": scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID],
                "Token": scripOrderInfo?.[WATCHLIST_GRID_INDEX.TOKEN],
                "Quantity": nQuantity,
                "Price": Math.round(nPrice * scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]),
                "MktFlag": selectOrderOption?.orderType?.includes('MKT') ? 1 : 0,
                "OldPrice": 0,
                "OldQuantity": 0,
                "ProductType": strProductType,
                "LegIndicator": 0
            }
        ];
        dispatch(getOrderMarginInfo(arrLegDetails));
    }, [activeButtonToggleIndex, dispatch, orderInputs, scripOrderInfo, selectOrderOption, toggleBracketOrder]);

    useEffect(() => {
        if (arrMarginInfo?.ApproxMargin && scripOrderInfo?.length > 0) {
            if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.NSE_DERIVATIVES || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.NCDEX_DERIVATIVES || ((scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.NSE_CASH || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.BSE_CASH) && scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT].toUpperCase() == SCRIP_INSTRUMENTS.EQUITIES && scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT] > 1)) {
                // nFundsRequiredPerLot = (parseFloat(arrMarginInfo?.ApproxMargin) * scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT]) / scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT];
                nFundsRequiredPerLot = (parseFloat(arrMarginInfo?.ApproxMargin) * scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT]) / orderInputs.scripQuantity;
            } else {
                // nFundsRequiredPerLot = parseFloat(arrMarginInfo?.ApproxMargin) / scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT];
                nFundsRequiredPerLot = parseFloat(arrMarginInfo?.ApproxMargin) / orderInputs.scripLot;
            }
        } else { }
    }, [arrMarginInfo, scripOrderInfo]);

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End



    //PrachiTawde : 09-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - End
    const handleClose = useCallback(() => {

        //BT-106965 : OrderCart :  ManasaB : 27/02/2024 - Start
        if (arrGridData.length != 0 && !bIsCartSavedSuccess && orderEntryTab == ORDER_TYPES.MULTI_SCRIP && activeTabKey == ORDER_TYPES.BASKET) {
            dispatch(handleModal([{ 'SAVE_CART_CONFIRM_MODAL': true }, true]));
            dispatch(handleModalData({ data: { orderEntryTab: ORDER_TYPES.MULTI_SCRIP } })); //BT-106965 : OrderCart :GoBack issue : 03-05-2024
        }
        else {
            dispatch(getScripOrderInfo({ isBuySell: ORDER_ENTRY_BUTTON_TOGGLE.BUY, activeExchangeId: MARKET_SEGMENT_ID.NSE_CASH, scripData: [] }));
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
            dispatch(toastConfig({ show: false }));
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
            dispatch(getSpreadOrderSuccess({}));
            setToggleBracketOrder(curr => ({ ...curr, isShow: false }));
            {/* Vinit R : 16-05-2024 :BT-107418 :Breeze - Order Book - SIP Order --- Start */ }
            setOrderInputs({ scripQuantity: 1, scripLot: 1, scripAmount: 0, scripPrice: '', slTrigger: 0, quantity: 1, capPrice: 0, numberOfInstallment: 1, intradayTrigger: 0, intradayLimit: 0, intradayTrailing: 0, intradayProfit: 0, discQty: 0, protPercent: 0, startDate: currentDate, gtdDate: defaultGtdDate, targetSelPrice: 0, targetSelTriggerPrice: 0 });// Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) 
            {/* Vinit R : 16-05-2024 :BT-107418 :Breeze - Order Book - SIP Order --- End */ }
            setLegDataInfo([]);
            // Vinit Raut : 30-04-2024 : BT-107418 - Breeze – SIP Order book bug fixing -- Start  
            setOrderEntryTab(ORDER_TYPES?.SINGLE_SCRIP);
            // Vinit Raut : 30-04-2024 : BT-107418 - Breeze – SIP Order book bug fixing -- End
            setThirdLegData([]);
            setSelectOrderOption(objSelectOrderOptionInit);
            dispatch(orderMarginInfoFailure(null));
            dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': false }]));
            dispatch(handleModalData({}));
            dispatch(getMarketStatusFailure([]));
            //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024  - Start
            dispatch(storeGridData([]));
            dispatch(saveCartForGoback({}));
            dispatch(saveCartSuccess(false));
            setIsBasket(false);
            setActiveTabKey(ORDER_TYPES.BASKET);
            dispatch(updateOrderCartRowData({}));//BT-106965 : Ordercart : Security Measures Warning : ManasaB : 25-04-2024 
            //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - End
        }
        dispatch(getMultiLegData([])); // Ajitesh 19-06-2024 Empty multi leg data for next render of order entry modal
    }, [orderEntryTab, activeTabKey, arrGridData]);
    //BT-106965 : OrderCa rt : ManasaB : 27/02/2024 - End
    //Ameersha N : 04-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - issue in re order its not taking default product type becasue of undefined Start
    const userPreference = useSelector(state => state.notification.userPreference);

    const objActiveExchangeUserPreference = useMemo(() => {
        if (userPreference?.length > 0 && userPreference[userPreference.length - 1]?.sExchange && scripOrderInfo?.length > 0) {
            const arrUserPreferenceProductType = JSON.parse(userPreference[userPreference.length - 1]?.sExchange);
            const objActiveExchangeUserPreference = arrUserPreferenceProductType?.find(obj => obj?.marketSegmentId == scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
            if (objActiveExchangeUserPreference && Object.keys(objActiveExchangeUserPreference).length > 0) {
                return objActiveExchangeUserPreference;
            } else {
                return {};
            }
        } else {
            return {};
        }
    }, [scripOrderInfo, userPreference]);
    //Ameersha N : 04-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - issue in re order its not taking default product type becasue of undefined Start
    const bIsSipAllowed = useMemo(() => {
        let bIsAllowed = false;
        if (objEqSIPScripMaster && scripOrderInfo) {
            bIsAllowed = _isEQSIPOrderAllowed(scripOrderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL], scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES], objEqSIPScripMaster);

        }
        return bIsAllowed;
    }, [objEqSIPScripMaster, scripOrderInfo]);
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    useEffect(() => {
        if (arrAllExchangeWiseProductTypes.length > 0) {
            const initProdType = selectOrderOption?.productType || objSelectOrderOptionInit.productType;
            const objSelProductType = arrAllExchangeWiseProductTypes?.find(obj => obj.sDefaultProductType == initProdType);

            //Ameersha N : 04-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - issue in re order its not taking default product type becasue of undefined Start
            let nIndexOfDefaultProductType = arrAllExchangeWiseProductTypes?.findIndex((eachItem) => (eachItem?.sDefaultProductType === objActiveExchangeUserPreference?.productType));
            //Ameersha N : 04-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - issue in re order its not taking default product type becasue of undefined End
            if (objSelProductType?.sDescription && !isModifyOrder && !isReOrder) {
                setSelectOrderOption(curr => ({ ...curr, productTypeDesc: objSelProductType?.sDescription.toUpperCase() }));
            } else { }
            //Ameersha N : 04-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - issue in re order its not taking default product type becasue of undefined Start

            // if (nIndexOfDefaultProductType >= 0 && !isModifyOrder && !isReOrder && selectOrderOption?.productTypeDesc?.length <= 0) {
            //     setSelectOrderOption(curr => ({ ...curr, productTypeDesc: arrAllExchangeWiseProductTypes[nIndexOfDefaultProductType]?.sDescription.toUpperCase() }));
            // } else if (!isModifyOrder && !isReOrder && (selectOrderOption?.productTypeDesc?.length <= 0 || selectOrderOption?.productType?.length <= 0)) {
            //     setSelectOrderOption(curr => ({
            //         ...curr, productTypeDesc: arrAllExchangeWiseProductTypes[0]?.sDescription.toUpperCase(), productType: arrAllExchangeWiseProductTypes[0]?.sDefaultProductType
            //     }));
            // } else { }
            //Ameersha N : 04-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - issue in re order its not taking default product type becasue of undefined End

            // }
        } else { }
    }, [arrAllExchangeWiseProductTypes, selectOrderOption?.productType, objActiveExchangeUserPreference]);

    useEffect(() => {
        if (!ltpPriceBandMaster) {
            dispatch(getLTPPriceBand());
        } else { }
    }, [ltpPriceBandMaster]);



    // eslint-disable-next-line react-hooks/exhaustive-deps
    const calculateQuantityAsPerAmount = (selAmount) => {
        const amt = parseFloat(selAmount);
        const price = parseFloat(orderInputs?.scripPrice);
        if (amt > 0 && price != 0 && scripOrderInfo?.length > 0) {
            let qty = '';
            if (!isNaN(nFundsRequiredPerLot) && nFundsRequiredPerLot != 0) {
                qty = Math.floor(amt / nFundsRequiredPerLot);
            }
            if ((scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.NSE_CASH || scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] == MARKET_SEGMENT_ID.BSE_CASH) && scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT].toUpperCase() == SCRIP_INSTRUMENTS.EQUITIES && scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT] > 1 && qty > 0) {
                qty = qty * scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT];
            }
            if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] != MARKET_SEGMENT_ID.NSE_CASH && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] != MARKET_SEGMENT_ID.BSE_CASH) {
                if ((scripOrderInfo?.[WATCHLIST_GRID_INDEX.OPTIONTYPE] == "CE" || scripOrderInfo?.[WATCHLIST_GRID_INDEX.OPTIONTYPE] == "PE") && activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
                    qty = Math.floor(amt / (price * scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT]));
                }
            }

            if ((selectOrderOption?.productType == ORDER_PRODUCT_TYPES.DELIVERY || selectOrderOption?.productType == ORDER_PRODUCT_TYPES.MTF || selectOrderOption?.productType == ORDER_PRODUCT_TYPES.PTST) && activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.SELL) {
                qty = Math.floor(amt / price);
            }

            if (!(isNaN(parseInt(qty))))
                var selQty = Math.abs(qty);

            else
                selQty = 0;

        } else {
            selQty = 0;
        }
        return selQty;
    };
    useEffect(() => {
        if (parseFloat(orderInputs?.scripAmount)) {
            const strAmount = isNaN(orderInputs?.scripAmount) ? 0 : orderInputs?.scripAmount?.toString().slice(0, ORDER_ENTRY_CONSTANTS.AMOUNT_LENGTH);
            const nAmount = isNaN(parseFloat(strAmount)) ? 0 : parseFloat(strAmount);
            const nLot = calculateQuantityAsPerAmount(nAmount);
            const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
            setOrderInputs(curr => ({ ...curr, ["scripAmount"]: strAmount, scripQuantity: parseInt(nLot * nScripReularLot), scripLot: nLot }));
        }
    }, [orderInputs?.scripPrice]);
    const handleOrderInputs = useCallback((event) => {
        const { name, value } = event.target;
        if (name == "capPrice") {
            setOrderInputs(curr => ({ ...curr, [name]: isNaN(value) ? 0 : value.slice(0, ORDER_ENTRY_CONSTANTS.CAP_PRICE_LENGTH) }));
        }
        //Maaz A : 24-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - Start
        else if (name == "scripLot") {
            const strLot = isNaN(value) ? 0 : value?.toString().slice(0, ORDER_ENTRY_CONSTANTS.QUANTITY_LENGTH);
            const nLot = parseInt(isNaN(parseInt(strLot)) ? 0 : strLot);
            const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
            setOrderInputs(curr => ({ ...curr, [name]: strLot, scripQuantity: parseInt(nLot * nScripReularLot) }));
        }
        else if (name == "scripAmount") {
            const strAmount = isNaN(value) ? 0 : value?.toString().slice(0, ORDER_ENTRY_CONSTANTS.AMOUNT_LENGTH);
            const nAmount = isNaN(parseFloat(strAmount)) ? 0 : parseFloat(strAmount);
            const nLot = calculateQuantityAsPerAmount(nAmount);
            const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
            setOrderInputs(curr => ({ ...curr, [name]: strAmount, scripQuantity: parseInt(nLot * nScripReularLot), scripLot: nLot }));
        }
        //Maaz A : 27-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE CDS Bug Fixes - Start
        else if (name == "scripQuantity") {
            const strScripQuantity = isNaN(value) ? 0 : value?.toString().slice(0, ORDER_ENTRY_CONSTANTS.QUANTITY_LENGTH);
            let nScripQuantity = parseInt(isNaN(parseInt(strScripQuantity)) ? 0 : strScripQuantity);
            const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
            let nUpdatedLot = parseInt(Math.round(nScripQuantity / nScripReularLot));
            setOrderInputs(curr => ({ ...curr, [name]: strScripQuantity, scripLot: nUpdatedLot }));
        }
        //Maaz A : 27-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE CDS Bug Fixes - End
        else if (name == "intradayTrailing") {
            setOrderInputs(curr => ({ ...curr, [name]: isNaN(value) ? 0 : value.slice(0, ORDER_ENTRY_CONSTANTS.QUANTITY_LENGTH) }));
        }
        //Maaz A : 24-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - End
        else if (name == "quantity") {
            setOrderInputs(curr => ({ ...curr, [name]: isNaN(value) ? 0 : value.slice(0, ORDER_ENTRY_CONSTANTS.QUANTITY_LENGTH) }));
        }
        else if (name == "numberOfInstallment") {
            setOrderInputs(curr => ({ ...curr, [name]: isNaN(value) ? 0 : value.slice(0, ORDER_ENTRY_CONSTANTS.NUMBER_OF_INSTALLMENT_LENGTH) }));
        }
        else if (name == "startDate") {
            setOrderInputs(curr => ({ ...curr, [name]: value }));
        }
        //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
        else if (name == "discQty") {
            setOrderInputs(curr => ({ ...curr, [name]: isNaN(value) ? 0 : value.slice(0, ORDER_ENTRY_CONSTANTS.QUANTITY_LENGTH) }));
        }
        else if (name == "protPercent") {
            setOrderInputs(curr => ({ ...curr, [name]: isNaN(value) ? 0 : value.slice(0, ORDER_ENTRY_CONSTANTS.PROTECTION_PERCENTAGE_LENGTH) }));
        }
        //Maaz A : 23-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - GTD Bug Fixes - Start
        else if (name == "gtdDate") {
            setOrderInputs(curr => ({ ...curr, [name]: isNaN(value) ? 0 : value }));
        }
        //Maaz A : 23-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - GTD Bug Fixes - End
        else {


            setOrderInputs(curr => ({
                ...curr, [name]: isNaN(value)
                    //Azeem K : 06-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - MCX Fixes - Start
                    && value?.toString() !== '-'
                    //Azeem K : 06-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - MCX Fixes - End
                    ? 0 : value.slice(0, ORDER_ENTRY_CONSTANTS.PRICE_LENGTH)
            }));
        }
        //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
    }, [calculateQuantityAsPerAmount, scripOrderInfo]);


    const handleOnSelectOrderOptionChange = useCallback((e) => {
        const { name, value } = e.target;
        // Maaz A: Commented toggle bracket to false because if open from external source and toggle bracket, it again make toggle false
        // setToggleBracketOrder(curr => ({ ...curr, isShow: false }));
        if (name == 'orderBy') {
            setSelectOrderOption(curr => ({ ...curr, [name]: value }));
            // if (value == 'Amount') {
            //     setOrderInputs(curr => ({ ...curr, quantity: 0, scripQuantity: 0, scripLot: 0, scripAmount: 1 }));
            // } else if (value == 'Lot') {
            //     setOrderInputs(curr => ({ ...curr, quantity: 0, scripQuantity: 0, scripLot: 1, scripAmount: 0 }));
            // }
        } else if (name == 'productType') {
            setSelectOrderOption(curr => ({ ...curr, [name]: value }));
            if (arrAllExchangeWiseProductTypes.length > 0) {
                const objSelProductType = arrAllExchangeWiseProductTypes?.find(obj => obj.sDefaultProductType == value);
                if (objSelProductType?.sDescription) {
                    setSelectOrderOption(curr => ({ ...curr, productTypeDesc: objSelProductType?.sDescription.toUpperCase() }));
                } else { }
            } else { }
        } else if (name == 'isAmo') {
            setSelectOrderOption(curr => ({ ...curr, [name]: value }));
            //Azeem K :  12-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NSEEQ Bug Fixes - Start
        } else if (name === 'orderType') {
            if (value === ORDER_ENTRY_TYPES.RL || value === ORDER_ENTRY_TYPES.RL_MKT || (selectOrderOption?.orderType === ORDER_ENTRY_TYPES.RL && value?.includes(ORDER_ENTRY_TYPES.SL))) {
                handleOrderInputs({ target: { name: 'slTrigger', value: '0.00' } });
            } else if (value === ORDER_ENTRY_TYPES.SL || value === ORDER_ENTRY_TYPES.SL_MKT) {
                setToggleBracketOrder(curr => ({ ...curr, isShow: false }));

            }
            setSelectOrderOption(curr => ({ ...curr, [name]: value }));
            //Azeem K :  12-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NSEEQ Bug Fixes - End
        }
        else {
            setSelectOrderOption(curr => ({ ...curr, [name]: value }));
        }
    }, [arrAllExchangeWiseProductTypes, selectOrderOption?.orderType]);



    const handleOrderStepsOnChange = useCallback((name, upDown) => {
        handleBlink(name + upDown); //Azeem K :05-08-2024 : pass id of any div to blink it in this case id is name + decrease/increase
        if (upDown === 'increase') {
            if (name === "capPrice") {
                setOrderInputs(curr => ({ ...curr, [name]: getToFixedParseFloat(Math.min((parseFloat(curr.capPrice) + scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK]), ORDER_ENTRY_CONSTANTS.CAP_PRICE_MAX_RANGE), scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) })); //BT-142330 :Hotfix Bug fixing : ManasaB : 27-08-2024 : Order SIP Cap price increment issue
            }
            else if (name == "scripLot") {
                let nLot = parseInt(isNaN(orderInputs?.scripLot) ? 0 : orderInputs?.scripLot);
                nLot = Math.min((nLot + 1), ORDER_ENTRY_CONSTANTS.QUANTITY_MAX_RANGE);
                const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
                setOrderInputs(curr => ({ ...curr, [name]: nLot, scripQuantity: parseInt(nLot * nScripReularLot) }));
            }
            //Maaz A : 24-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - Start
            else if (name == "scripAmount") {
                let nAmount = isNaN(parseFloat(orderInputs.scripAmount)) ? 0 : parseFloat(orderInputs.scripAmount);
                nAmount = Math.min(nAmount + 1, ORDER_ENTRY_CONSTANTS.AMOUNT_MAX_RANGE);
                const nLot = calculateQuantityAsPerAmount(nAmount);
                const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
                setOrderInputs(curr => ({ ...curr, [name]: nAmount, scripQuantity: parseInt(nLot * nScripReularLot), scripLot: nLot }));
            }
            else if (name === "scripQuantity") {
                let nScripQuantity = parseInt(isNaN(orderInputs?.scripQuantity) ? 0 : orderInputs?.scripQuantity);
                const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
                if (nScripQuantity % nScripReularLot === 0) {
                    var nUpdatedScripQuantity = Math.min(parseInt(nScripQuantity + nScripReularLot), ORDER_ENTRY_CONSTANTS.QUANTITY_MAX_RANGE);
                } else {
                    nUpdatedScripQuantity = Math.min(parseInt(Math.ceil(nScripQuantity / nScripReularLot) * nScripReularLot), ORDER_ENTRY_CONSTANTS.QUANTITY_MAX_RANGE);
                }
                let nUpdatedLot = parseInt(Math.round(nUpdatedScripQuantity / nScripReularLot));
                setOrderInputs(curr => ({ ...curr, scripLot: nUpdatedLot, [name]: nUpdatedScripQuantity }));
            }
            //Maaz A : 24-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FO Bug Fixes - End
            else if (name === "quantity" || name === "intradayTrailing") {
                setOrderInputs(curr => ({ ...curr, [name]: Math.min(isNaN(parseInt(curr[name])) ? 0 : parseInt(curr[name]) + 1, ORDER_ENTRY_CONSTANTS.QUANTITY_MAX_RANGE) }));
            }
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
            else if (name === "discQty") {
                if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) {
                    var nMaxDiscQty = parseInt(orderInputs?.scripQuantity);
                } else {
                    nMaxDiscQty = parseInt(orderInputs?.scripLot);
                }
                setOrderInputs(curr => ({ ...curr, [name]: Math.min(isNaN(parseInt(curr[name])) ? 0 : parseInt(curr[name]) + 1, nMaxDiscQty) }));
            }
            else if (name === "protPercent") {
                setOrderInputs(curr => ({ ...curr, [name]: Math.min(isNaN(parseFloat(curr[name])) ? 0 : parseFloat(curr[name]) + 1, ORDER_ENTRY_CONSTANTS.PROTECTION_PERCENTAGE_MAX_RANGE) }));
            }
            // Vinit Raut : 17-01-2024 : BT-107249 - Breeze – SIP Order entry bug fixing BT-102676 -- Start  
            else if (name === "numberOfInstallment") {
                if (orderEntryTab === ORDER_TYPES.EQUITY_SIP) {
                    setOrderInputs(curr => ({ ...curr, [name]: Math.min(isNaN(parseFloat(curr[name])) ? sipSettingDetails?.frequency_details[selectOrderOption?.frequency]?.installment_min : parseFloat(curr[name]) + 1, sipSettingDetails?.frequency_details[selectOrderOption.frequency]?.installment_max) }));
                } else {
                    setOrderInputs(curr => ({ ...curr, [name]: Math.min(isNaN(parseFloat(curr[name])) ? 0 : parseFloat(curr[name]) + 1, ORDER_ENTRY_CONSTANTS.NUMBER_OF_INSTALLMENT_MAX_RANGE) }));
                }
            }
            // Vinit Raut : 17-01-2024 : BT-107249 - Breeze – SIP Order entry bug fixing BT-102676 -- End 
            else {
                setOrderInputs(curr => {
                    const nRoundedPrice = roundToNearest(parseFloat(curr[name]), scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK], 'up');
                    let nMaxValue = Math.min(isNaN(nRoundedPrice) ? 0 : nRoundedPrice + scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK], ORDER_ENTRY_CONSTANTS.PRICE_MAX_RANGE);
                    let PriceinPaise = parseInt(Math.round(parseFloat((nMaxValue * scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]).toString())).toString());
                    let selPriceTick = scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] * scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
                    if (PriceinPaise % parseInt(selPriceTick) != 0) {
                        //Price correction to nearest value.
                        nMaxValue = (parseFloat(nMaxValue) - (PriceinPaise % parseInt(selPriceTick)) / parseInt(scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]));
                    }
                    return { ...curr, [name]: isNaN(parseFloat(curr[name])) ? 0 : getToFixedParseFloat(nMaxValue, scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) };
                });
            }
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End

        } else if (upDown === 'decrease') {

            if (name == "capPrice") {

                setOrderInputs(curr => ({ ...curr, [name]: getToFixedParseFloat(Math.max(parseFloat(curr[name]) - scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK], 0), scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) }));//BT-142330 :Hotfix Bug fixing : ManasaB : 27-08-2024 : Order SIP Cap price decrement issue

            } else if (name == "numberOfInstallment") {
                // Vinit Raut : 17-01-2024 : BT-107249 - Breeze – SIP Order entry bug fixing BT-102676 -- Start  
                if (orderEntryTab === ORDER_TYPES.EQUITY_SIP) {
                    setOrderInputs(curr => ({ ...curr, [name]: Math.max(parseFloat(curr[name]) - 1, sipSettingDetails?.frequency_details[selectOrderOption?.frequency]?.installment_min) }));
                } else {
                    setOrderInputs(curr => ({ ...curr, [name]: Math.max(parseFloat(curr[name]) - 1, 0) }));
                }
                // Vinit Raut : 17-01-2024 : BT-107249 - Breeze – SIP Order entry bug fixing BT-102676 -- End  
            } else if (name == "scripLot") {
                let nLot = parseInt(isNaN(orderInputs?.scripLot) ? 0 : orderInputs?.scripLot);
                nLot = Math.max((nLot - 1), 0);
                const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
                setOrderInputs(curr => ({ ...curr, [name]: nLot, scripQuantity: parseInt(nLot * nScripReularLot) }));
            }
            else if (name == "scripAmount") {
                let nAmount = isNaN(parseFloat(orderInputs.scripAmount)) ? 0 : parseFloat(orderInputs.scripAmount);
                nAmount = Math.max(nAmount - 1, 0);
                const nLot = calculateQuantityAsPerAmount(nAmount);
                const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
                setOrderInputs(curr => ({ ...curr, [name]: nAmount, scripQuantity: parseInt(nLot * nScripReularLot), scripLot: nLot }));
            }
            else if (name === "scripQuantity") {
                let nScripQuantity = parseInt(isNaN(orderInputs?.scripQuantity) ? 0 : orderInputs?.scripQuantity);
                const nScripReularLot = scripOrderInfo?.length > 0 ? scripOrderInfo?.[WATCHLIST_GRID_INDEX.REGULAR_LOT] : 1;
                if (nScripQuantity % nScripReularLot === 0) {
                    nUpdatedScripQuantity = parseInt((nScripQuantity - nScripReularLot));
                } else {
                    nUpdatedScripQuantity = parseInt(Math.floor(nScripQuantity / nScripReularLot) * nScripReularLot);
                }
                nUpdatedScripQuantity = Math.max(nUpdatedScripQuantity, 0);
                let nUpdatedLot = parseInt(Math.round(nUpdatedScripQuantity / nScripReularLot));
                setOrderInputs(curr => ({ ...curr, scripLot: nUpdatedLot, [name]: nUpdatedScripQuantity }));
            }
            else if (name === "quantity" || name == "intradayTrailing") {
                setOrderInputs(curr => ({ ...curr, [name]: Math.max(isNaN(parseInt(curr[name])) ? 0 : parseInt(curr[name]) - 1, 0) }));
            }
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
            else if (name === "discQty") {
                setOrderInputs(curr => ({ ...curr, [name]: Math.max(isNaN(parseInt(curr[name])) ? 0 : parseInt(curr[name]) - 1, 0) }));
            }
            else if (name === "protPercent") {
                setOrderInputs(curr => ({ ...curr, [name]: Math.max(isNaN(parseFloat(curr[name])) ? 0 : parseFloat(curr[name]) - 1, 0) }));
            }
            else {
                if (parseFloat(orderInputs[name]) <= 0) {
                    setOrderInputs(curr => {
                        return {
                            ...curr, [name]: isNaN(curr[name]) ? 0 : getToFixedParseFloat(0, scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])
                        };
                    });
                } else {
                    setOrderInputs(curr => {
                        let nMinValue = roundToNearest(parseFloat(curr[name]), scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK], 'down') - scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK];
                        let PriceinPaise = parseInt(Math.round(parseFloat((nMinValue * scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]).toString())).toString());
                        let selPriceTick = scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] * scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
                        if (PriceinPaise % parseInt(selPriceTick) != 0) {
                            //Price correction to nearest value.
                            nMinValue = (parseFloat(nMinValue) - (PriceinPaise % parseInt(selPriceTick)) / parseInt(scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]));
                        }
                        return {
                            ...curr, [name]: isNaN(curr[name]) ? 0 : getToFixedParseFloat(nMinValue, scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])
                        };
                    });
                }
            }
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End

        }
    }, [scripOrderInfo, orderInputs, calculateQuantityAsPerAmount]);

    {/* BT-107418- 15/04/2024 - Vinit R - 28/03/2024 Breeze SIP order entry issues -- Start */ }
    const handleFortnightlyFrequencyChange = (e) => {
        const { value } = e.target;
        setSelectOrderOption(curr => ({ ...curr, selectSpecificFrequencyDate: value }));
    };

    {/* BT-107418- 30/04/2024 - Vinit R -Breeze SIP order entry issues -- Start */ }

    let frequency
    let Weekly
    let days
    if (sipSettingDetails?.frequency_details) {
        frequency = Object.keys(sipSettingDetails?.frequency_details);
        Weekly = sipSettingDetails?.frequency_details?.WEEKLY?.specific_week_days;
        days = sipSettingDetails?.frequency_details[selectOrderOption?.frequency]?.specific_dates;
    } else {
        frequency = [];
        Weekly = [];
        days = [];
    }
    useEffect(() => {

        if (selectOrderOption?.frequency === FREQUENCY_TYPE.MONTHLY) {
            setSelectOrderOption(curr => ({ ...curr, selectSpecificFrequencyDate: (days?.length === 1 && days[0] === "") || days?.length === 0 ? new Date().getDate() : days[0] }));
        } else if (selectOrderOption?.frequency === FREQUENCY_TYPE.FORTHNIGHTLY) {
            setSelectOrderOption(curr => ({ ...curr, selectSpecificFrequencyDate: days?.length > 0 && days[0] ? days[0] : 15 }));
        } else if (selectOrderOption?.frequency === FREQUENCY_TYPE.WEEKLY) {
            setSelectOrderOption(curr => ({ ...curr, everyForWeekly: Weekly?.length > 0 && Weekly[0] ? Weekly[0] : "MONDAY" }));
        }
    }, [selectOrderOption?.frequency,]);
    {/* BT-107418- 30/04/2024 - Vinit R -Breeze SIP order entry issues -- End */ }
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

    /*Mahesh S  : 19-06-2023 : BT-102838 -  Breeze - Net Position - Start*/
    const handleNetPositionOrderInputs = () => {
        setOrderInputs({ scripQuantity: 1, scripPrice: parseInt(modalData?.avg_buy_price), slTrigger: 0, quantity: 1, capPrice: 0, numberOfInstallment: 0, intradayTrigger: 0, intradayLimit: 0, intradayTrailling: 0, intradayProfit: 0 });
        setToggleBracketOrder(curr => ({ ...curr, isShow: false }));
        // setOrderEntryTab(ORDER_TYPES.SINGLE_SCRIP)
    };
    /*Mahesh S  : 19-06-2023 : BT-102838 -  Breeze - Net Position - End*/



    useEffect(() => {
        if (modalData?.daily_or_expiry) {
            handleNetPositionOrderInputs();
        } else { }
    }, [modalData]);

    // Vinit R : 27-02-2023 : BT-117133 - Breeze - Recommendations bug fixing -- Start
    // Ameersha : 14-03-2024 : BT-117133 - Breeze - Recommendations bug fixing -- Start
    useEffect(() => {
        setSelectOrderOption(curr => {
            return {
                ...curr,
                productType: objModalData?.data?.productType ? objModalData?.data?.productType : curr?.productType,
                orderType: objModalData?.data?.orderType ? objModalData?.data?.orderType : curr?.orderType,
                productTypeDesc: objModalData?.data?.productTypeDesc ? objModalData?.data?.productTypeDesc : curr?.productTypeDesc
            };
        });

        let intervalId = setTimeout(() => {
            setOrderInputs(curr => ({

                ...curr,
                slTrigger: objModalData?.data?.SLPrice ? objModalData?.data?.SLPrice : curr?.slTrigger,
                scripPrice: objModalData?.data?.scripPrice ? objModalData?.data?.scripPrice : curr?.scripPrice,
                scripQuantity: objModalData?.data?.scripQuantity || objModalData?.data?.scripQuantity === 0 ? objModalData?.data?.scripQuantity : curr?.scripQuantity,
                scripLot: objModalData?.data?.scripLot || objModalData?.data?.scripLot === 0 ? objModalData?.data?.scripLot : curr?.scripLot
            }));
        }, 200);

        return () => clearTimeout(intervalId);
    }, [objModalData?.data]);
    // Ameersha : 14-03-2024 : BT-117133 - Breeze - Recommendations bug fixing -- End
    // Vinit R : 27-02-2023 : BT-117133 - Breeze - Recommendations bug fixing -- End

    const updateActiveButtonToggleIndex = useCallback((nIsBuyOrSell) => {
        setToggleBracketOrder(curr => ({ ...curr, isShow: false, strProductType: ORDER_PRODUCT_TYPES.COVER }));
        dispatch(getScripOrderInfo({ isBuySell: nIsBuyOrSell, activeMktSegId, scripData: scripOrderInfo, isReOrder: isReOrder }));
    }, [activeMktSegId, scripOrderInfo, isReOrder]);

    // useSingleKey('f1', (e) => {
    //     e.preventDefault(); // Prevent the default browser behavior for F1 key press
    //     if (activeButtonToggleIndex !== ORDER_ENTRY_BUTTON_TOGGLE.BUY && !isModifyOrder && !bIsHoldingsSell && orderEntryTab !== ORDER_TYPES.EQUITY_SIP) {
    //         updateActiveButtonToggleIndex(ORDER_ENTRY_BUTTON_TOGGLE.BUY);
    //     }
    // });
    // useSingleKey('f2', (e) => {
    //     e.preventDefault(); // Prevent the default browser behavior for F1 key press
    //     if (activeButtonToggleIndex !== ORDER_ENTRY_BUTTON_TOGGLE.SELL && !isModifyOrder && !bIsHoldingsSell && orderEntryTab !== ORDER_TYPES.EQUITY_SIP) {
    //         updateActiveButtonToggleIndex(ORDER_ENTRY_BUTTON_TOGGLE.SELL);
    //     }
    // });
    // useSingleKey('+', (e) => {
    //     if (tabSearchToggle || isExpanded?.containerLength !== '0%' || modals['ORDER_ENTRY_MODAL'] || modals['MARKET_OVERVIEW_MODAL']) {
    //         return
    //     } else {
    //         e.preventDefault(); // Prevent the default browser behavior for F1 key press
    //     }
    //     if (activeButtonToggleIndex !== ORDER_ENTRY_BUTTON_TOGGLE.BUY && !isModifyOrder && !bIsHoldingsSell && orderEntryTab !== ORDER_TYPES.EQUITY_SIP) {
    //         updateActiveButtonToggleIndex(ORDER_ENTRY_BUTTON_TOGGLE.BUY);
    //     }
    // }); // DO NOT REMOVE AS MIGHT NEED FOR LATER
    // useSingleKey('-', (e) => {
    //     if (tabSearchToggle || isExpanded?.containerLength !== '0%' || modals['ORDER_ENTRY_MODAL'] || modals['MARKET_OVERVIEW_MODAL']) {
    //         return
    //     } else {
    //         e.preventDefault(); // Prevent the default browser behavior for F1 key press
    //     }
    //     if (activeButtonToggleIndex !== ORDER_ENTRY_BUTTON_TOGGLE.SELL && !isModifyOrder && !bIsHoldingsSell && orderEntryTab !== ORDER_TYPES.EQUITY_SIP) {
    //         updateActiveButtonToggleIndex(ORDER_ENTRY_BUTTON_TOGGLE.SELL);
    //     }
    // });
    // Maaz A - For Pre Setting Order Entry Values - Start

    const setIsScripPrice = (bIsSetPrice) => {
        isScripPrice = bIsSetPrice;
    };

    //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
    useImperativeHandle(ref, () => ({
        orderInputs,
        setOrderInputs,
        selectOrderOption,
        setSelectOrderOption,
        setToggleBracketOrder,
        isScripPrice,
        setIsScripPrice
    }));
    //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
    // Maaz A - For Pre Setting Order Entry Values - End
    // ---BT-113521_SrikanthRao_17-07-2023-end

    // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - Start
    useEffect(() => {
        if (orderEntryTab === ORDER_TYPES.EQUITY_SIP && activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.SELL) {
            updateActiveButtonToggleIndex(ORDER_ENTRY_BUTTON_TOGGLE.BUY);
        }
    }, [orderEntryTab, activeButtonToggleIndex]);
    // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - End

    //Maaz A : 01-12-2023 : BT-102298 - Breeze - Single Scrip Order entry - GTD Bug Fixes - Start
    const strSelectedExchName = useMemo(() => getApiExchangeNameFromMktSegId(scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]), [scripOrderInfo]);
    const validityTypes = useMemo(() => {
        const arrSelectedExchangeValidity = getValidityByExchangeName(strSelectedExchName, objCFT?.GTTSUPPORT === FACILITY_NUM.ON); // Azeem K:07-05 - 2025 : added conditionally GTT and GTD 
        if (arrSelectedExchangeValidity?.length > 0) {
            var arrFinalValidity = arrSelectedExchangeValidity.filter(strValidity => _isShowValidityOrderEntry(scripOrderInfo, strValidity, selectOrderOption, isModifyOrder, objCFT?.GTTSUPPORT === FACILITY_NUM.ON));// Azeem K:07-05 - 2025 : added conditionally GTT and GTD 
        } else {
            arrFinalValidity = arrSelectedExchangeValidity;
        }
        if (!isModifyOrder && !isReOrder && arrFinalValidity?.length > 0) {
            handleOnSelectOrderOptionChange({ target: { name: 'validityTypes', value: arrFinalValidity[0] } });
        }

        if (arrFinalValidity?.length > 0 && !arrFinalValidity?.includes(selectOrderOption?.validityTypes)) {
            handleOnSelectOrderOptionChange({ target: { name: 'validityTypes', value: arrFinalValidity[0] } });

        }

        return arrFinalValidity;
    }, [strSelectedExchName, scripOrderInfo, selectOrderOption?.productType, selectOrderOption?.orderType, isModifyOrder, isReOrder, objCFT]);
    //Maaz A : 01-12-2023 : BT-102298 - Breeze - Single Scrip Order entry - GTD Bug Fixes - End

    {/* Vinit Raut : 30-04-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- Start   */ }
    useEffect(() => {
        if (objModalData?.data?.orderEntryTab && (objModalData?.data?.orderEntryTab === ORDER_TYPES.SINGLE_SCRIP || objModalData?.data?.orderEntryTab === ORDER_TYPES.MULTI_SCRIP || objModalData?.data?.orderEntryTab === ORDER_TYPES.EQUITY_SIP)) {
            setOrderEntryTab(objModalData?.data?.orderEntryTab);
        } else {
            // setOrderEntryTab(ORDER_TYPES.SINGLE_SCRIP); // not needed - Parshva S - 22/04 - BT 102679 - Multileg Order Entry
        }
        if (objModalData?.data?.activeTabKey) {
            setActiveTabKey(objModalData?.data?.activeTabKey);
        }
    }, [objModalData?.data?.orderEntryTab, objModalData?.data?.activeTabKey]);
    {/* Vinit Raut : 30-04-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- End   */ }
    // const handleKeyPressOnDiv = (e) => {
    //     if (e?.code === 'Space' || e?.key === ' ' || e?.key === 'Enter') {
    //         e?.target?.click();
    //     }
    //     // if ((e?.target?.id === ORDER_TYPES.SINGLE_SCRIP || e?.target?.id === ORDER_TYPES.MULTI_SCRIP || e?.target?.id === ORDER_TYPES.EQUITY_SIP) && (e?.key === 'Enter' || e?.code === 'Space')) {
    //     //     setOrderEntryTab(e?.target?.id);
    //     // }
    // };

    const handleKeyEvents = useCallback((e) => {
        let key = e?.key?.toLowerCase();
        switch (key) {
            case 'f1':
                e.preventDefault(); // Prevent the default browser behavior for F1 key press
                if (activeButtonToggleIndex !== ORDER_ENTRY_BUTTON_TOGGLE.BUY && !isModifyOrder && !bIsHoldingsSell && orderEntryTab !== ORDER_TYPES.EQUITY_SIP) {
                    updateActiveButtonToggleIndex(ORDER_ENTRY_BUTTON_TOGGLE.BUY);
                }

            case 'f2':
                e.preventDefault(); // Prevent the default browser behavior for F1 key press
                if (activeButtonToggleIndex !== ORDER_ENTRY_BUTTON_TOGGLE.SELL && !isModifyOrder && !bIsHoldingsSell && orderEntryTab !== ORDER_TYPES.EQUITY_SIP) {
                    updateActiveButtonToggleIndex(ORDER_ENTRY_BUTTON_TOGGLE.SELL);
                }

        }
    }, [updateActiveButtonToggleIndex, activeButtonToggleIndex, isModifyOrder, bIsHoldingsSell, activeMktSegId, scripOrderInfo]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyEvents);
        return () => {
            document.removeEventListener('keydown', handleKeyEvents);
        };
    }, [handleKeyEvents]);

    useEffect(() => {
        if (Object.keys(objEqSIPScripMaster)?.length === 0 && !isGuestUser()) {
            dispatch(getEqSipScripMaster());
        } else { }
    }, [dispatch]);
    return (
        <>
            <BzModal centered size="lg" show={modals['ORDER_ENTRY_MODAL']} onHide={handleClose} >
                <FocusLock lockProps={{ style: { 'overflowY': 'auto' } }} >
                    <BzModalHeader className='modaltabs-header pb-0'>
                        <Container fluid className='p-0'>
                            <Row className='g-0'>
                                {
                                    isModifyOrder ?
                                        <Col className='d-flex justify-content-start align-items-end mb-2'>
                                            <BzModalTitle className='font-medium font-size6 color-text'>Modify Order</BzModalTitle>
                                        </Col>
                                        :
                                        <Col className='d-flex justify-content-start align-items-end'>
                                            <BzTabs className='nav nav-tabs'>
                                                <BzTab className='nav-link text-capitalize' isActive={ORDER_TYPES.SINGLE_SCRIP === orderEntryTab} tabKey={ORDER_TYPES.SINGLE_SCRIP} onClick={() => {
                                                    if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.NSPREAD] === 1) {
                                                        dispatch(getScripOrderInfo({ isBuySell: ORDER_ENTRY_BUTTON_TOGGLE.BUY, activeExchangeId: scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE], scripData: [] }));
                                                    }
                                                    setOrderEntryTab(ORDER_TYPES.SINGLE_SCRIP);
                                                }
                                                } id={ORDER_TYPES.SINGLE_SCRIP} tabIndex='0' onKeyPress={handleKeyDownOnDiv}>Single Scrip</BzTab>
                                                {
                                                    (objCFT.MULTILEG == FACILITY_NUM.ON || objCFT.BULKORDER == FACILITY_NUM.ON) &&
                                                    <BzTab className='nav-link text-capitalize' isActive={ORDER_TYPES.MULTI_SCRIP === orderEntryTab} tabKey={ORDER_TYPES.MULTI_SCRIP} onClick={() => setOrderEntryTab(ORDER_TYPES.MULTI_SCRIP)} id={ORDER_TYPES.MULTI_SCRIP} tabIndex='0' onKeyPress={handleKeyDownOnDiv}>Multi Scrip</BzTab>
                                                }
                                                {
                                                    (objCFT.SIPORSWP === FACILITY_NUM.ON) ?
                                                        <BzTab className='nav-link text-capitalize' isActive={ORDER_TYPES.EQUITY_SIP === orderEntryTab} tabKey={ORDER_TYPES.EQUITY_SIP} onClick={() => setOrderEntryTab(ORDER_TYPES.EQUITY_SIP)} id={ORDER_TYPES.EQUITY_SIP} tabIndex='0' onKeyPress={handleKeyDownOnDiv}>SIP</BzTab>
                                                        : null
                                                }
                                            </BzTabs>
                                        </Col>
                                }
                                {
                                    orderEntryTab !== ORDER_TYPES.MULTI_SCRIP &&
                                    <Col md={2} className={`d-flex justify-content-end align-items-center mb-2 ${isModifyOrder || bIsHoldingsSell ? 'disabled' : ''}`}>
                                        {orderEntryTab === ORDER_TYPES.EQUITY_SIP ?
                                            <div className='buy-wrap-sip'><div className='btn btn-sm btn-positive'>Buy</div></div>
                                            :
                                            <BzToggleButton
                                                wrapperClassName={`buysell-wrap ${orderEntryTab === ORDER_TYPES.EQUITY_SIP && (scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] != 'EQ' || !bIsSipAllowed) ? 'd-none' : ''}`}
                                                leftButtonClassName={`btn btn-sm ${activeButtonToggleIndex === 0 ? 'btn-positive' : ''}`}
                                                rightButtonClassName={`btn btn-sm ${activeButtonToggleIndex === 1 ? 'btn-negative' : ''}`}
                                                leftButtonTitle="BUY" rightButtonTitle="SELL" activeButtonToggleIndex={activeButtonToggleIndex} setActiveButtonToggleIndex={updateActiveButtonToggleIndex}
                                                isDisabled={isModifyOrder || bIsHoldingsSell || orderEntryTab === ORDER_TYPES.EQUITY_SIP}  // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  
                                            />
                                        }
                                    </Col>
                                }
                                <Col md={1} className='d-flex justify-content-end align-items-center mb-2'>
                                    <div onClick={handleClose} className='icon-16 icon-close icon-dark ms-3' />
                                </Col>
                            </Row>
                        </Container>
                    </BzModalHeader>
                    <BzModalBody >
                        <BzTabsContainer>
                            {
                                orderEntryTab === ORDER_TYPES.SINGLE_SCRIP &&
                                //Maaz A : 09-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - LiveFeed Issue Fix - Start
                                <OrderSingleScrip key={ORDER_TYPES.SINGLE_SCRIP} isScripPrice={isScripPrice} setIsScripPrice={setIsScripPrice} arrAllExchangeWiseProductTypes={arrAllExchangeWiseProductTypes} bIsPlaceOrderBtnDisabled={bIsPlaceOrderBtnDisabled} setArrAllExchangeWiseProductTypes={setArrAllExchangeWiseProductTypes} activeMktSegId={activeMktSegId} handleOrderStepsOnChange={handleOrderStepsOnChange} activeButtonToggleIndex={activeButtonToggleIndex} orderInputs={orderInputs} setOrderInputs={setOrderInputs} layoutType={LAYOUT_TYPE.HORIZONTAL} toggleBracketOrder={toggleBracketOrder} setToggleBracketOrder={setToggleBracketOrder} selectOrderOption={selectOrderOption} handleOnSelectOrderOptionChange={handleOnSelectOrderOptionChange} handleOrderInputs={handleOrderInputs} marginInfoHandler={marginInfoHandler} arrMarginInfo={arrMarginInfo} scripOrderInfo={scripOrderInfo} market={''} isBrokerageDisabled={isBrokerageDisabled} isModifyOrder={isModifyOrder} nOriginalQty={nOriginalQty} isReOrder={isReOrder} objSelectOrderOptionInit={objSelectOrderOptionInit} validityTypes={validityTypes} bIsHoldingsSell={bIsHoldingsSell} setSelectOrderOption={setSelectOrderOption} />
                                //Maaz A : 09-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - LiveFeed Issue Fix - End
                            }
                            {
                                (orderEntryTab === ORDER_TYPES.MULTI_SCRIP) &&
                                <OrderMultiScrip key={ORDER_TYPES.MULTI_SCRIP} layoutType={LAYOUT_TYPE.HORIZONTAL} scripOrderInfo={scripOrderInfo}
                                    activeButtonToggleIndex={activeButtonToggleIndex} isBasket={isBasket} setIsBasket={setIsBasket} show={show} setAddToggle={setAddToggle} addToggle={addToggle} setShow={setShow}
                                    addScript={addScript} thirdlegData={thirdlegData} arrMarginInfo={arrMarginInfo} marginInfoHandler={marginInfoHandler}
                                    count={count} setCount={setCount} buySellType={buySellType} setBuySellType={setBuySellType}
                                    activeTabKey={activeTabKey} setActiveTabKey={setActiveTabKey} arrAllExchangeWiseProductTypes={arrAllExchangeWiseProductTypes}
                                    setThirdLegData={setThirdLegData} isDeletedFlag={isDeletedFlag} setIsdeletedFlag={setIsdeletedFlag}
                                    legDataInfo={legDataInfo} setLegDataInfo={setLegDataInfo} isCheck={isCheck} setIsCheck={setIsCheck} isBrokerageDisabled={isBrokerageDisabled}
                                    orderEntryTab={orderEntryTab} isModifyOrder={isModifyOrder} isMultilegReOrder={isMultilegReOrder} setArrAllExchangeWiseProductTypes={setArrAllExchangeWiseProductTypes}
                                />
                            }
                            {
                                // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - Start 
                                orderEntryTab === ORDER_TYPES.EQUITY_SIP &&
                                <OrderSip handleFortnightlyFrequencyChange={handleFortnightlyFrequencyChange} setOrderEntryTab={setOrderEntryTab} key={ORDER_TYPES.EQUITY_SIP} orderEntryTab={orderEntryTab} handleOrderStepsOnChange={handleOrderStepsOnChange} handleOrderInputs={handleOrderInputs} layoutType={LAYOUT_TYPE.HORIZONTAL} handleOnSelectOrderOptionChange={handleOnSelectOrderOptionChange} selectOrderOption={selectOrderOption} orderInputs={orderInputs} marginInfoHandler={marginInfoHandler} arrMarginInfo={arrMarginInfo} activeButtonToggleIndex={activeButtonToggleIndex} scripOrderInfo={scripOrderInfo} isBrokerageDisabled={isBrokerageDisabled} isModifyOrder={isModifyOrder} objSelectOrderOptionInit={objSelectOrderOptionInit} setSelectOrderOption={setSelectedCategory} bIsSipAllowed={bIsSipAllowed} />
                                // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - End 
                            }
                        </BzTabsContainer>
                    </BzModalBody>
                </FocusLock>
            </BzModal>
            {
                modals['ORDER_ENTRY_CONFIRMATION'] ?
                    <ConfirmationModal
                        layoutType={LAYOUT_TYPE.HORIZONTAL} defaultGtdDate={defaultGtdDate}
                        marginInfoHandler={marginInfoHandler} getScripOrderInfo={getScripOrderInfo}
                        setToggleBracketOrder={setToggleBracketOrder} setOrderInputs={setOrderInputs}
                        setLegDataInfo={setLegDataInfo} setActiveTabKey={setActiveTabKey}
                        setThirdLegData={setThirdLegData} setSelectOrderOption={setSelectOrderOption}
                        setOrderEntryTab={setOrderEntryTab} activeContent={activeContent}
                        // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                        ordersTabKey={ordersTabKey}
                    // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
                    />
                    :
                    null
            }
            {
                modals['ORDER_STATUS'] &&
                <OrderStatus layoutType={LAYOUT_TYPE.HORIZONTAL} defaultGtdDate={defaultGtdDate} activeTabKey={activeTabKey} getScripOrderInfo={getScripOrderInfo} setToggleBracketOrder={setToggleBracketOrder} setOrderInputs={setOrderInputs} setLegDataInfo={setLegDataInfo} setActiveTabKey={setActiveTabKey} setThirdLegData={setThirdLegData} setSelectOrderOption={setSelectOrderOption} setOrderEntryTab={setOrderEntryTab}
                    // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                    ordersTabKey={ordersTabKey}
                // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End

                />
            }
            {/* ManasaB : 10-07-2024 : Resolved bug in side bar Single scrip  - Start : ManasaB :14-082-2024 : Hotfix issue*/}
            {modals['ORDER_CART_NAME_MODAL'] && <OrderCartModal />}
            {/* ManasaB : 10-07-2024 : Resolved bug in side bar Single scrip  - End : ManasaB :14-082-2024 : Hotfix issue*/}
            <SaveCartCnfrmModal setOrderEntryTab={setOrderEntryTab} setActiveTabKey={setActiveTabKey} />   {/* BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024 */}
            {/* <LoginLoader spinner={bIsOrderCartConfirmApiStatus} spinnerContent="Fetching Details" /> */}
            {/* //BT-107437: Functional Implementation InvestMents : Vaibhav Singh : 21-08-2023 : Changes SUggested By prachi for Brokerage*/}
            {
                modals['ORDER_ENTRY_MODAL'] ?
                    <BrokerageCharges brokerageParams={getBrokerageParams()} activeButtonToggleIndex={activeButtonToggleIndex} />
                    : null}
        </>
    );
});

export default memo(OrderEntry);

